var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.pageUrl))?_c('mpx-web-view',{attrs:{"src":(_vm.pageUrl)},on:{"load":_vm.loadSuccess,"error":_vm.loadFail}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }